"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.4.1'] && _();
}
catch (e) { }
